export const MatchSteps = {
    WEALTH_LEVEL_QUESTION: 1,
    LOCATION_QUESTION: 2,
    CONTACT_FORM: 3,
};



// WEBPACK FOOTER //
// ./src/constants/MatchSteps.js